import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Created by <b><a href="https://portuspk.com/" target="_blank">Portus</a></b> 2025
    </span>
    <div class="socials">
      <a href="https://www.instagram.com/portuspk/" target="_blank" class="ion ion-social-instagram"></a>
      <a href="https://www.facebook.com/portuspk" target="_blank" class="ion ion-social-facebook"></a>
      <a href="https://x.com/portuspk" target="_blank" class="ion ion-social-twitter"></a>
      <a href="https://pk.linkedin.com/company/portuspk" target="_blank" class="ion ion-social-linkedin"></a>
    </div>
  `,
})
export class FooterComponent {
}
